var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SchemaTablePage", {
    ref: "tablePageRef",
    attrs: {
      "layout-mode": "tab",
      "show-summary": "",
      "search-schema": _vm.searchSchema,
      columns: _vm.tableColumns,
      "default-query": _vm.defaultQuery,
      request: _vm.request,
      "build-params": _vm.buildParams,
      "parse-result": _vm.parseResult,
      "table-attrs": _vm.tableAttrs,
    },
    scopedSlots: _vm._u([
      {
        key: "search-amountRange",
        fn: function ({ query }) {
          return [
            _c(
              "div",
              { staticClass: "amount-range" },
              [
                _c("el-input-number", {
                  attrs: { controls: false, placeholder: "最小金额", min: 0 },
                  model: {
                    value: query.minOrderAmount,
                    callback: function ($$v) {
                      _vm.$set(query, "minOrderAmount", $$v)
                    },
                    expression: "query.minOrderAmount",
                  },
                }),
                _c("div", { staticStyle: { width: "10px" } }),
                _c("el-input-number", {
                  attrs: { controls: false, placeholder: "最大金额", min: 0 },
                  model: {
                    value: query.maxOrderAmount,
                    callback: function ($$v) {
                      _vm.$set(query, "maxOrderAmount", $$v)
                    },
                    expression: "query.maxOrderAmount",
                  },
                }),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "colMemberAccount",
        fn: function ({ row }) {
          return [
            _c("MemberAccountCell", {
              attrs: {
                row: row,
                username: row.memberAccount,
                uid: row.uid,
                "vip-level": row.memberLevel,
              },
            }),
          ]
        },
      },
      {
        key: "colOrderAmount",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.orderAmount)))]
        },
      },
      {
        key: "colOrderStatus",
        fn: function ({ row }) {
          return [
            _c(
              "el-tag",
              {
                attrs: {
                  size: "mini",
                  type: _vm.getStatusTagType(row.orderStatus),
                },
              },
              [_vm._v(_vm._s(row.orderStatus))]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }